import { initializeApp } from 'firebase/app';
import { getFirestore } from 'firebase/firestore';
import { getAnalytics } from 'firebase/analytics';

const firebaseConfig = {
    apiKey: "AIzaSyDJVyht6EFTOkaZombgKrGDlYhf0PfXJDE",
    authDomain: "hostal-185a2.firebaseapp.com",
    projectId: "hostal-185a2",
    storageBucket: "hostal-185a2.firebasestorage.app",
    messagingSenderId: "184705524000",
    appId: "1:184705524000:web:816f2a53f42b1e7f8a3745",
    measurementId: "G-DYVSSW5PM6"
  };

// Initialize Firebase
const app = initializeApp(firebaseConfig);
export const db = getFirestore(app);
export const analytics = getAnalytics(app); 